import { getAuthHeadersOrRedirect } from './ticketingApi';

const toArray = (value) => (Array.isArray(value) ? value : []);

export const EXECUTION_ACTION_LABELS = {
  investigation_started: 'Investigasi dimulai',
  topology_opened: 'Topology dibuka',
  recovery_opened: 'Recovery dibuka',
  ticket_created: 'Ticket dibuat',
  ticket_updated: 'Ticket diperbarui',
  backup_verified: 'Backup diverifikasi',
  mitigation_started: 'Mitigasi dimulai',
  mitigation_completed: 'Mitigasi selesai',
  manual_note: 'Catatan manual',
};

export const getExecutionActionLabel = (actionType) => {
  const token = String(actionType || '').trim().toLowerCase();
  return EXECUTION_ACTION_LABELS[token] || token || 'Aksi';
};

export const mapExecutionLogItem = (item = {}) => ({
  ...item,
  id: String(item.id || ''),
  sourceType: String(item.source_type || item.sourceType || 'manual').toLowerCase(),
  sourceId: String(item.source_id || item.sourceId || ''),
  incidentId: String(item.incident_id || item.incidentId || ''),
  ticketId: String(item.ticket_id || item.ticketId || ''),
  customerId: String(item.customer_id || item.customerId || ''),
  routerId: String(item.router_id || item.routerId || ''),
  nodeId: String(item.node_id || item.nodeId || ''),
  siteId: String(item.site_id || item.siteId || ''),
  actionType: String(item.action_type || item.actionType || 'manual_note').toLowerCase(),
  message: String(item.message || ''),
  actor: String(item.actor || '-'),
  createdAt: item.created_at || item.createdAt || '',
});

export async function fetchExecutionLogs({ apiBase, navigate, params = {} }) {
  const headers = getAuthHeadersOrRedirect(navigate);
  if (!headers) return { items: [], total: 0 };

  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return;
    query.set(key, String(value));
  });

  const response = await fetch(`${apiBase}/execution-logs${query.toString() ? `?${query.toString()}` : ''}`, {
    headers,
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload?.detail || 'Gagal memuat execution log.');
  }
  const payload = await response.json();
  const items = toArray(payload?.items).map(mapExecutionLogItem);
  return { items, total: Number(payload?.total || items.length) };
}

export async function createExecutionLog({ apiBase, navigate, payload = {} }) {
  const headers = getAuthHeadersOrRedirect(navigate);
  if (!headers) return null;

  const response = await fetch(`${apiBase}/execution-logs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...headers },
    body: JSON.stringify(payload || {}),
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.detail || 'Gagal menyimpan execution log.');
  }

  return mapExecutionLogItem(result?.item || {});
}

